export const FareCalculator = (
    distance,
    time,
    rateDetails,
    instructionData,
    decimal
) => {
    const safeNumber = (value, fallback = 0) => {
        const parsed = Number.parseFloat(value);
        return Number.isFinite(parsed) ? parsed : fallback;
    };

    const distanceValue = safeNumber(distance);
    const timeValue = safeNumber(time);
    const ratePerDistance = safeNumber(
        rateDetails?.rate_per_unit_distance
    );
    const ratePerHour = safeNumber(rateDetails?.rate_per_hour);
    const baseFare = safeNumber(rateDetails?.base_fare);
    const minimumFare = safeNumber(rateDetails?.min_fare);
    const decimalPlaces = Number.isInteger(Number(decimal))
        ? Number(decimal)
        : 2;

    let baseCalculated =
        ratePerDistance * distanceValue +
        ratePerHour * (timeValue / 3600) +
        baseFare;

    if (instructionData?.parcelTypeSelected) {
        baseCalculated += safeNumber(
            instructionData.parcelTypeSelected.amount
        );
    }

    if (instructionData?.optionSelected) {
        baseCalculated += safeNumber(
            instructionData.optionSelected.amount
        );
    }

    const total = Math.max(baseCalculated, minimumFare);

    let convenienceFee = 0;

    if (rateDetails?.convenience_fee_type === "flat") {
        convenienceFee = safeNumber(rateDetails?.convenience_fees);
    } else {
        const conveniencePercentage = safeNumber(
            rateDetails?.convenience_fees
        );

        convenienceFee = total * conveniencePercentage / 100;
    }

    const grandTotal = total + convenienceFee;

    return {
        totalCost: Number(total.toFixed(decimalPlaces)),
        grandTotal: Number(grandTotal.toFixed(decimalPlaces)),
        convenience_fees: Number(
            convenienceFee.toFixed(decimalPlaces)
        )
    };
};